// Balance Dashboard Main Page Component
export default {
  // Beginner Guide
  finishButton: "Finish",

  // Search Box
  searchPlaceholder: "Please enter the case you want to search",
  confirmButton: "Confirm",

  // Title
  balanceDashboard: "Balance Dashboard",
  updateData: "Update Data",

  // Loading and Tips
  loading: "Loading...",
  tronUpdateInfo: "Tron chain data can be manually updated. Update time:",

  // Dropdown Selection
  pleaseSelect: "Please select",
  all: "All",

  // Dialog
  tronUpdateSuccess: "Tron Data Updated Successfully",
  updateSuccessMessage:
    "Update successful! Balance dashboard data will be synchronized after confirmation",
  closeButton: "Close",
  confirmButtonDialog: "Confirm",

  // Error Messages
  noSearchResult: "No results found for your search!",
  noCaseData:
    "No case data available. You can add addresses to case data analysis through the canvas",
};
